// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
// import axios from 'axios';
import VueResource from 'vue-resource';
import { sync } from 'vuex-router-sync';
import auth from 'vue-hamlet';

import {
  Col, Row, Menu,
  Submenu, Select, Option,
  MenuItem, MenuItemGroup, Card,
  Dropdown, DropdownMenu, DropdownItem,
  Switch, Button, Input,
  Form, FormItem, Upload,
  Radio, RadioGroup, RadioButton, Tabs,
  TabPane, Tag, Table,
  TableColumn, Dialog, Pagination,
  Checkbox, CheckboxGroup, CheckboxButton, Loading, Message,
  MessageBox, Collapse, CollapseItem,
  Progress, Popover, Tooltip,
  Notification, Alert, DatePicker,
} from 'element-ui';
import moment from 'moment';
import './styles/index.scss';
import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';
import API from './api';
import utils from './utils';
import * as consts from './utils/consts';

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueResource);

Vue.use(Col);
Vue.use(Row);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Card);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Switch);
Vue.use(Button);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Upload);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CheckboxButton);
Vue.use(Loading);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Progress);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Alert);
Vue.use(DatePicker);


Vue.prototype.$consts = consts;
Vue.prototype.$moment = moment;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$notify = Notification;
Vue.prototype.$api = API;
Vue.prototype.$utils = utils;
Vue.router = router;
Vue.store = store;

Vue.prototype.$locale = {
  use(lang) {
    i18n.locale = lang;
    localStorage.setItem('HAMLET_LANGUAGE', lang);
  },
  current() {
    return i18n.locale;
  },
};

Vue.use(auth, {
  appKey: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
  authRedirect: '/login',
  allowThirdpartyLogin: true,
});
sync(store, router);

Vue.router.beforeEach((to, from, next) => {
  let locale = to.query.locale;
  if (!locale) {
    locale = 'zh';
  } else {
    /* eslint-disable no-param-reassign */
    delete to.query.locale;
    i18n.locale = locale;
    localStorage.setItem('HAMLET_LANGUAGE', locale);
    next({ path: to.path, query: to.query });
  }
  next();
});

let userLocale = navigator.language || navigator.userLanguage;
userLocale = userLocale.split('-')[0];
i18n.locale = localStorage.getItem('HAMLET_LANGUAGE') || userLocale;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js